import React from 'react';
import PropTypes from 'prop-types';

import { ReactComponent as Arrow } from 'icons/Arrow.svg';

import ChangesItemValue from './ChangesItemValue';
import ArrowRightWrapper from './ArrowRightWrapper';
import ContentBlock from './ContentBlock';
import ChangesItem from './ChangesItem';

const ACTION_TYPES = {
  title: 'Название',
  content: 'Контент',
  subtitle: 'Подзаголовок',
  chatTitle: 'Заголовок чата',
  publishedAt: 'Дата опубликования',
  mascotPhrase: 'Фраза маскота',
  mascotType: 'Тип маскота',
  negativeReaction: 'Негативная реакция',
  positiveReaction: 'Позитивная реакция',
  postType: 'Тип публикации',
  state: 'Статус публикции',
  postId: 'id публикации',
  snoozeId: 'id снуза',
  ownerId: 'id публикации',
  employeeId: 'id сотрудника',
  emotion: 'Градиент',
  createdAt: 'Создана в',
  isPinned: 'Запинить публикацию',
  isPush: 'Отправить пуш',
  isAdult: '18+',
  isAuthorizedOnly: 'Только для авторизованных',
  isNoise: 'Информационный шум',
  isPartner: 'Партнерский материал',
  destination: 'Отправить публикацию',
  author: 'Автор',
  sourceLink: 'Источник',
};

class AuditChangesItem extends React.PureComponent {
  render() {
    return (
      <ChangesItem>
        {ACTION_TYPES[this.props.actionType] || this.props.actionType}

        <ContentBlock>
          <ChangesItemValue error>{String(this.props.item[0])}</ChangesItemValue>

          <ArrowRightWrapper><Arrow /></ArrowRightWrapper>

          <ChangesItemValue>{String(this.props.item[1])}</ChangesItemValue>
        </ContentBlock>
      </ChangesItem>
    );
  }
}

AuditChangesItem.propTypes = {
  item: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.number])),
  actionType: PropTypes.string.isRequired,
};

AuditChangesItem.defaultProps = {
  item: [],
};

export default AuditChangesItem;
